import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { secondsToHHMMSS } from '@helpers/secondsToHHMMSS';
import type { JobsReportDTO } from 'app/API';
import { JOB_STATUSES_ENUM } from 'app/types/enums/jobStatuses';

export const USER_JOBS_REPORT_CSV_HEADERS = [
  'ID',
  'Member',
  'Job Title',
  'Organization',
  'Workspace',
  'Status',
  'Created',
  'Duration',
];

export type TUserJobsReportCsvSource = Pick<
  JobsReportDTO,
  'id' | 'name' | 'lastname' | 'email' | 'jobName' | 'status' | 'createdAt' | 'duration'
>;

type TContext = {
  organizationName: string;
  workspaceName: string;
};

export const buildUserJobsReportCsvRows = (
  jobs: TUserJobsReportCsvSource[],
  { organizationName, workspaceName }: TContext,
) =>
  jobs.map((job) => ({
    id: job.id,
    member: `${job.name} ${job.lastname} (${job.email})`,
    jobName: job.jobName ?? '',
    organization: organizationName,
    workspace: workspaceName,
    status: JOB_STATUSES_ENUM[job.status as keyof typeof JOB_STATUSES_ENUM],
    created: getAmericanTime(job.createdAt),
    duration: secondsToHHMMSS(job.duration ?? 0),
  }));
